import { render, staticRenderFns } from "./boxLesson.vue?vue&type=template&id=fec1ab94&"
import script from "./boxLesson.vue?vue&type=script&lang=js&"
export * from "./boxLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports